import { Routes, Route } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import ProfilePage from "../pages/Account/Profile/ProfilePage";
import PaymentPage from "../features/Checkout/Payment/pages/PaymentPage";
import SuccessPage from "../features/Checkout/Payment/pages/SuccessPage";
import ReturnExchange from "../pages/Account/ReturnExchange/Returnexchange";
import ReturnExchangeSuccess from "../pages/Account/ReturnExchange/ReturnExchangeSuccess";
import ContentPolicy from "../features/content/policy/pages/PolicyPage";
import AboutPage from "../features/content/about/pages/AboutPage";
import ContactPage from "../features/content/contact/pages/ContactPage";
import Faq from "../features/content/faq/pages/FaqPage";
import StyleGuidePage from "../features/content/guides/styleGuide/pages/StyleGuidePage";
import SizeGuidePage from "../features/content/guides/sizeGuide/pages/SizeGuidePage";
import HomePage from "../features/Home/pages/HomePage";
import TrackOrderPage from "../features/content/tracking/pages/TrackOrderPage";
import VideoGalleryPage from "../features/content/gallery/video/pages/VideoGalleryPage";
import ProductsPage from "../features/products/listing/pages/ProductsPage";
import FloorMatcher from "../features/products/floorMatcher/pages/floorMatcherPage";
import CollectionPage from "../features/collection/pages/CollectionPage";
import ProductDetail from "../features/products/pdp/pages/ProductDetailPage";
import PromotionsPage from "../features/products/promotion/pages/PromotionsPage";
import OrderDetailPage from "../features/account/order/pages/OrderDetail/OrderDetailPage";
import OrderTrackingPage from "../features/account/order/pages/TrackingOrder/OrderTrackingPage";
import BlogPage from "../features/content/blog/bloglist/pages/BlogPage";
import BlogPostPage from "../features/content/blog/blogpost/pages/BlogPostPage";
import CheckoutPage from "../features/Checkout/Summay/pages/CheckoutPage";
import CartPage from "../features/Checkout/Cart/pages/CartPage";
import PaymentCheckPage from "../features/Checkout/Payment/pages/PaymentCheckPage";
import CancelOrderPage from "../features/account/order/pages/CancelOrder/CancelOrderPage";
import ReturnOrderPage from "../features/account/order/pages/ReturnOrder/ReturnOrderPage";
import PageNotFound from "../features/Error/PageNotFound";
import AuthLoginPage from "../features/auth/pages/AuthLoginPage";
import PaymentFailedPage from "../features/Checkout/Payment/pages/PaymentFailedPage";
import PageServerError from "../features/Error/PageServerError";


const AppRoutes = () => {
  return (
    // <ScrollToTopWrapper>
    <Routes>

      <Route path="/" element={<MainLayout />}>
        <Route index element={<HomePage />} />
        {/* Collections */}
        <Route path="collections">
          <Route index element={<CollectionPage />} />
          <Route path=":categorySlug" element={<CollectionPage />} />
        </Route>

        {/* Products */}
        {/* <Route path="products">
          <Route index element={<ProductsPage />} />
          <Route path=":categorySlug" element={<ProductsPage />} />
          <Route path=":categorySlug/:subcategorySlug" element={<ProductsPage />} />
        </Route> */}

        <Route path="floor-matcher" element={<FloorMatcher />} />
        <Route path="search" element={<PromotionsPage />} />

        {/* <Route path="products"> */}
        <Route path="/">
          <Route index element={<ProductsPage />} />
          <Route path=":categorySlug" element={<ProductsPage />} />
          <Route path=":categorySlug/:subcategorySlug" element={<ProductsPage />} />
        </Route>

        {/* Product Details */}

        <Route path=":slug/:sku/buy" element={<ProductDetail />} />
        {/* <Route path="productsdetails/:slug" element={<ProductDetail />} /> */}
        {/* Cart & Checkout */}
        <Route path="cart" element={<CartPage />} />

        <Route path="checkout">
          <Route path="init" element={<CheckoutPage />} />
          <Route path="payment/:token" element={<PaymentPage />} />
          {/* Order Status */}
          <Route path=":token/order-confirmed" element={<SuccessPage />} />
          <Route path="order-failed" element={<PaymentFailedPage />} />
        </Route>
        
        {/* Orders */}
        <Route path="accounts">
          <Route path="orders">
            {/* Orders List */}
            <Route index element={<ProfilePage />} />
            <Route path=":orderNo" element={<OrderDetailPage />} />
            <Route path=":orderNo/cancel" element={<CancelOrderPage />} />

            <Route path=":orderNo/return" element={<ReturnOrderPage />} />
            <Route path=":orderNo/exchange" element={<CancelOrderPage />} />


            {/* Order Tracking */}
            <Route path="order-tracking">
              <Route index element={<OrderTrackingPage />} />
              <Route path=":orderNo" element={<OrderTrackingPage />} />
            </Route>

            {/* Returns & Exchange */}
            <Route path="return-exchange" element={<ReturnExchange />} />
            <Route path="return-success" element={<ReturnExchangeSuccess />} />
            <Route path="exchange-success" element={<ReturnExchangeSuccess />} />
            <Route path="cancel-order" element={<CancelOrderPage />} />
          </Route>

          <Route path="profile" element={<ProfilePage />} />
          <Route path="addresses" element={<ProfilePage />} />
        </Route>
        {/* Auth & Profile */}
        <Route path="login" element={<AuthLoginPage />} />
        {/* Tools */}
        {/* <Route path="search" element={<Searchlist />} /> */}
        {/* Static Pages */}
        <Route path="pages/about-us" element={<AboutPage />} />
        <Route path="contact-us" element={<ContactPage />} />
        <Route path="faq" element={<Faq />} />
        {/** Tracking Related Page */}
        <Route path="track">
          <Route path="shipments" element={<TrackOrderPage />} />
        </Route>
        {/* Blog */}
        <Route path="blog">
          <Route index element={<BlogPage />} />
          <Route path=":blog" element={<BlogPostPage />} />
        </Route>
        {/* Legal */}
        <Route path="policy">
          <Route path=":page_slug" element={<ContentPolicy />} />
        </Route>
        {/* Legal */}
        {/* Marketing Pages */}
        <Route
          path="/shop/:promotionType"
          element={<PromotionsPage />}
        />
        {/* Media */}
        <Route path="reels" element={<VideoGalleryPage />} />
        <Route path="style-guide" element={<StyleGuidePage />} />
        <Route path="size-guide" element={<SizeGuidePage />} />
      </Route>
        {/* Payment Handlers Callbacks */}
        <Route path="payment">
          <Route path="callback" element={<PaymentCheckPage />} />
        </Route>
      <Route path="/error/404" element={<PageNotFound />} />
      <Route path="/error/500" element={<PageServerError />} />

      <Route path="*" element={<PageNotFound />} />
    </Routes >
    // </ScrollToTopWrapper>
  );
};

export default AppRoutes;
